import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import Cookies from 'js-cookie'
import { handleAlert } from '../functions/handleAlert'

export const getOrderCounter=createAsyncThunk("orderCounter/getOrderCounter",async()=>{
  const token = Cookies.get(`${process.env.REACT_APP_TOKEN_NAME}`) 
  const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/order/counters`,{
    headers:{
      Authorization:`Bearer ${token}`
    }
  })
  console.log(res.data);
  return res.data
})

const initialState = {
  orderCounter:0,
  isLoading:true
}

export const orderCounterSlice = createSlice({
  name: 'orderCounter',
  initialState,
  reducers: {
  },
  extraReducers:(builder)=>{
    builder.addCase(getOrderCounter.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getOrderCounter.fulfilled, (state, { payload }) => {
      state.orderCounter = payload
      state.isLoading = false
    })
    builder.addCase(getOrderCounter.rejected, (_, action) => {
      if (action.payload) {
        handleAlert(action.payload.errorMessage , "error") 
      } else {
        handleAlert(action.error.message, "error") 
      }
    })
  }
})

export default orderCounterSlice.reducer